import { toast } from 'react-hot-toast'
import { FormTemplate } from 'types/graphql'

const printForm = (formTemplate: FormTemplate, submissionData?: unknown) => {
  try {
    const printWindow = window.open('/form-renderer.html', '_blank')
    if (!printWindow) {
      toast.error('Popup blocked. Please allow popups to print the form.')
      return
    }

    const init = () => {
      try {
        printWindow.postMessage(
          {
            type: 'INIT_FORM',
            data: {
              formTemplate,
              formSubmission: submissionData,
              options: {
                readOnly: false,
                removeInteractiveElements: true,
                noAlerts: true,
                noDefaultSubmitButton: true,
              },
            },
          },
          window.location.origin
        )
      } catch (e) {
        console.error('Failed to print form', e)
      }
      printWindow.removeEventListener('load', init)
    }

    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) {
        return // Security check
      }

      const { type } = event.data
      if (type === 'FORM_INITIALIZED') {
        printWindow.postMessage({ type: 'PRINT' }, window.location.origin)
        printWindow.removeEventListener('message', handleMessage)
      }
    }

    // Some browsers fire load synchronously; handle both cases safely
    try {
      printWindow.addEventListener('load', init)
    } catch (e) {
      console.error('Failed to open print window', e)
      // Fallback: try to init after a short delay
      setTimeout(init, 300)
    }

    try {
      printWindow.addEventListener('message', handleMessage)
    } catch (e) {
      console.error('Failed to add message listener', e)
      toast.error('An error occurred.  Please try again.')
    }
  } catch (e) {
    console.error('Failed to open print window', e)
    toast.error('Failed to open print view')
  }
}

export default printForm
